import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'
import { ASSIGNMENT_ITEM_STATUS } from '@/constants/assignmentItemStatus'

const AssignmentStore = {
  namespaced: true,
  state: {
    assignments: [],
    statusCounters: {
      TOTAL: 0,
      [ASSIGNMENT_ITEM_STATUS.PENDING]: 0,
      [ASSIGNMENT_ITEM_STATUS.ACCEPTED]: 0,
      [ASSIGNMENT_ITEM_STATUS.REJECTED]: 0
    },
    countPending: 0
  },
  getters,
  mutations,
  actions
}

export default AssignmentStore
